import { render, staticRenderFns } from "./thirdPart.vue?vue&type=template&id=5c50f739"
import script from "./thirdPart.vue?vue&type=script&lang=js"
export * from "./thirdPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports